import {
  createMemberRoleDefinition as publicCreateMemberRoleDefinition,
  listMemberRoleDefinitions as publicListMemberRoleDefinitions,
  getMemberRoleDefinition as publicGetMemberRoleDefinition,
  updateMemberRoleDefinition as publicUpdateMemberRoleDefinition,
  deleteMemberRoleDefinition as publicDeleteMemberRoleDefinition,
} from './members-v1-member-role-definition-member-role-definition.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const createMemberRoleDefinition: MaybeContext<
  BuildRESTFunction<typeof publicCreateMemberRoleDefinition> &
    typeof publicCreateMemberRoleDefinition
> = /*#__PURE__*/ createRESTModule(publicCreateMemberRoleDefinition);
export const listMemberRoleDefinitions: MaybeContext<
  BuildRESTFunction<typeof publicListMemberRoleDefinitions> &
    typeof publicListMemberRoleDefinitions
> = /*#__PURE__*/ createRESTModule(publicListMemberRoleDefinitions);
export const getMemberRoleDefinition: MaybeContext<
  BuildRESTFunction<typeof publicGetMemberRoleDefinition> &
    typeof publicGetMemberRoleDefinition
> = /*#__PURE__*/ createRESTModule(publicGetMemberRoleDefinition);
export const updateMemberRoleDefinition: MaybeContext<
  BuildRESTFunction<typeof publicUpdateMemberRoleDefinition> &
    typeof publicUpdateMemberRoleDefinition
> = /*#__PURE__*/ createRESTModule(publicUpdateMemberRoleDefinition);
export const deleteMemberRoleDefinition: MaybeContext<
  BuildRESTFunction<typeof publicDeleteMemberRoleDefinition> &
    typeof publicDeleteMemberRoleDefinition
> = /*#__PURE__*/ createRESTModule(publicDeleteMemberRoleDefinition);

export {
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
} from './members-v1-member-role-definition-member-role-definition.universal.js';
export {
  MemberRoleDefinition,
  SyncMetaSiteRolesRequest,
  SyncMetaSiteRolesResponse,
  CreateMemberRoleDefinitionRequest,
  CreateMemberRoleDefinitionResponse,
  ListMemberRoleDefinitionsRequest,
  ListMemberRoleDefinitionsResponse,
  GetMemberRoleDefinitionRequest,
  GetMemberRoleDefinitionResponse,
  UpdateMemberRoleDefinitionRequest,
  UpdateMemberRoleDefinitionResponse,
  DeleteMemberRoleDefinitionRequest,
  DeleteMemberRoleDefinitionResponse,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  Empty,
  CreateMemberRoleDefinitionOptions,
  UpdateMemberRoleDefinitionOptions,
} from './members-v1-member-role-definition-member-role-definition.universal.js';
export {
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  UpdateMemberRoleDefinitionApplicationErrors,
  DeleteMemberRoleDefinitionApplicationErrors,
} from './members-v1-member-role-definition-member-role-definition.universal.js';
